import { useCallback, useEffect, useState } from 'react';
import { useResizeObserver } from "../../../helper/hooks/useResizeObserver.js";
export function useWidth(ref) {
  const [width, setWidth] = useState();
  useResizeObserver(ref, useCallback(rect => {
    setWidth(rect?.width + 1);
  }, []));
  useEffect(() => {
    function onResize() {
      if (ref.current) {
        const boundingRect = ref.current.getBoundingClientRect();
        setWidth(Math.floor(boundingRect.width + 1));
      }
    }
    onResize();
    document.addEventListener('scroll', onResize);
    return () => {
      document.removeEventListener('scroll', onResize);
    };
  }, [ref]);
  return width;
}